/**
 * BlankGrid — the canvas placeholder shown when the tabletop has no
 * active map (a brand-new campaign, or before the GM sets/uploads one).
 *
 * Replaces the old hardcoded "Test Arena" PIXI map that used to flash on
 * load. Deliberately inert: a neutral square grid on the darkest surface,
 * no tokens, no controls. The GM creates a map from the Map tab; once an
 * active map exists, App swaps this out for <VTTCanvas>.
 *
 * Rendered as a sibling of (not inside) VTTCanvas so the heavy canvas
 * component only ever mounts with a real map — keeping its hook order
 * stable (see App's `hasActiveMap` gate).
 */
export function BlankGrid({ isGM }: { isGM: boolean }) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Neutral square grid (graph-paper feel) on the deepest surface.
        backgroundColor: 'hsl(var(--ac-surface-0))',
        backgroundImage: `
          linear-gradient(hsl(var(--ac-text-light) / 0.05) 1px, transparent 1px),
          linear-gradient(90deg, hsl(var(--ac-text-light) / 0.05) 1px, transparent 1px)
        `,
        backgroundSize: '50px 50px, 50px 50px',
      }}
    >
      <div
        className="font-serif-ac"
        style={{
          color: 'hsl(var(--ac-text-muted))',
          fontSize: '0.9375rem',
          letterSpacing: '0.02em',
          textAlign: 'center',
          maxWidth: 360,
          padding: '0 1.5rem',
          lineHeight: 1.5,
        }}
      >
        {isGM
          ? 'No map yet — create or upload one from the Map tab to set the scene.'
          : 'Waiting for the GM to set up the tabletop…'}
      </div>
    </div>
  )
}
